import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// resolve a relative /api/... asset path to an absolute URL
export const asset = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};

export const CATEGORIES = ["All", "Sunrise", "Sunset", "Night Sky", "Weather", "Ocean", "Desert", "Urban"];

export const PHOTO_CATEGORIES = ["All", "Wedding", "Sports", "Portrait", "Landscape", "Event"];

export const BRAND = "Scott Burton Photography";

export const formatUSD = (n) =>
  (n ?? 0).toLocaleString("en-US", { style: "currency", currency: "USD" });
